import { QuoteToolPreselectedModes } from '@lx/shared/utils';
import { z } from 'zod';
import { optionalDateSchema } from './optional-date.schema';

/**
 * Schema for representing the parameters of the AYA deep link.
 * All fields are optional. When no deep link parameters are provided,
 * the strategy will return basic AYA flow data without preselected values.
 */
export const AcademicYearAbroadDeepLinksParametersSchema = z
  .object({
    preselectedMode: z.enum(QuoteToolPreselectedModes),
    languageCode: z.string(),
    courseCode: z.string(),
    schoolCode: z.string(),
    duration: z.number().min(1),
    startDate: optionalDateSchema,
    deeplinkType: z.string(),
  })
  .partial();
